import React, { useMemo, useState, useEffect, ReactElement } from 'react';
import { Point } from 'highcharts';
import { SeriesAlertId } from 'components/report-content/components/kpi-chart/series';
import KpiAlertTooltip from 'components/report-content/components/kpi-chart/parts/tooltip/KpiAlertTooltip';
import KpiMeasureSeriesTooltip from 'components/report-content/components/kpi-chart/parts/tooltip/KpiMeasureSeriesTooltip';

export function useTooltip() {
    const [hoveredChartPoint, setHoveredChartPoint] = useState<Point | null>(null);
    const [selectedChartPoint, setSelectedChartPoint] = useState<Point | null>(null);
    const [isPointSelected, setIsPointSelected] = useState<boolean>(false);

    useEffect(() => {
        setIsPointSelected(selectedChartPoint != null);
    }, [selectedChartPoint]);

    const pointToShow = useMemo(() => {
        return selectedChartPoint ? selectedChartPoint : hoveredChartPoint;
    }, [selectedChartPoint, hoveredChartPoint]);
    const handlePointClick = (point: Point) => {
        setSelectedChartPoint(point);
    };

    const handlePointMouseOver = (point: Point) => {
        if (isPointSelected) {
            return;
        }
        setHoveredChartPoint(point);
    };

    const handlePointMouseOut = () => {
        if (isPointSelected) {
            return;
        }
        setHoveredChartPoint(null);
    };

    const handlePointClose = () => {
        setSelectedChartPoint(null);
        setHoveredChartPoint(null);
    };

    let Tooltip: ReactElement | null = null;
    if (pointToShow) {
        const seriesId = pointToShow.series?.userOptions.id;
        if (seriesId == SeriesAlertId) {
            Tooltip = (
                <KpiAlertTooltip isSelected={isPointSelected} point={pointToShow} onClose={() => handlePointClose()} />
            );
        } else {
            Tooltip = (
                <KpiMeasureSeriesTooltip
                    isSelected={isPointSelected}
                    point={pointToShow}
                    onClose={() => handlePointClose()}
                />
            );
        }
    }
    return { Tooltip, handlePointClick, handlePointMouseOver, handlePointMouseOut, handlePointClose, pointToShow };
}
